import { render, staticRenderFns } from "./IntentSamples.vue?vue&type=template&id=67114a0e"
import script from "./IntentSamples.vue?vue&type=script&lang=js"
export * from "./IntentSamples.vue?vue&type=script&lang=js"
import style0 from "./IntentSamples.vue?vue&type=style&index=0&id=67114a0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports